export const APP_CONFIG = {
  defaultDateFormat: "dd/MM/yyyy",
  defaultDateTimeFormat: "dd/MM/yyyy, HH:mm",
  tutorPlaceholderPath: "/images/tutorblind.png",
};
